import React, { Component } from 'react';

class ExamLayoutBtn extends Component {
    render() {
        return (
            <div className="view-select-wrap">
                <span>화면<br/>배치</span>
                <div className="btn-wrap">
                    <button className="btn one-view active" onClick={this.props.onLayoutChange}></button>
                    <span>1단 보기</span>
                </div>
                <div className="btn-wrap">
                    <button className="btn two-view" onClick={this.props.onLayoutChange}></button>
                    <span>2단 보기</span>
                </div>
            </div>
        );
    }
}

export default ExamLayoutBtn;